import * as angular from 'angular';

import { AlarmLevel } from '../../models/enum';
import { severityLevels } from '../../common/constants';
import { ComponentDefinition, KeyValuePair } from '../../models';

class SeveritySelectController implements angular.IComponentController {
    currentLevels: KeyValuePair<AlarmLevel, string>[];
    model: AlarmLevel;

    readonly isDisabled: boolean;
    readonly levels: KeyValuePair<AlarmLevel, string>[];
    readonly propertyName: string;

    static $inject = [];

    $onInit() {
        if (!this.currentLevels) {
            this.currentLevels = severityLevels;
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (!this.model) {
            this.model = AlarmLevel.Information;
        }
        if (changesObj['levels']?.currentValue && this.levels.length > 0) {
            this.currentLevels = Object.assign({}, this.levels);
        } else {
            this.currentLevels = severityLevels;
        }
    }
}

export const wtSeveritySelect: ComponentDefinition = {
    componentId: 'wtSeveritySelect',
    controller: SeveritySelectController,
    controllerAs: 'vm',
    template: require('./severitySelect.component.html'),
    bindings: {
        isDisabled: '<',
        levels: '<?',
        model: '=',
        onChange: '&?',
        propertyName: '<'
    }
};